//core
import React from "react";
import { Box, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

interface ITotalCellTooltipProps {
  tooltipKey?: string;
  children: React.ReactNode;
}

const TotalCellTooltip: React.FC<ITotalCellTooltipProps> = ({ tooltipKey, children }) => {
  const { t } = useTranslation();

  if (!tooltipKey) {
    return <>{children}</>;
  }

  return (
    <Tooltip title={t(tooltipKey)} placement="bottom" arrow>
      <Box component="span">
        {children}
      </Box>
    </Tooltip>
  );
};

export default TotalCellTooltip;
